export const kpiCards = [
  {
    title: 'Revenue (30d)',
    value: '$124,300',
    delta: '+18.4%',
    tone: 'positive'
  },
  {
    title: 'Orders (30d)',
    value: '1,482',
    delta: '+6.7%',
    tone: 'positive'
  },
  {
    title: 'Refund Rate',
    value: '1.2%',
    delta: '-0.3%',
    tone: 'positive'
  },
  {
    title: 'AOV',
    value: '$83.87',
    delta: '-2.1%',
    tone: 'negative'
  }
];

export const revenueByWeek = [
  { label: 'W1', revenue: 22300 },
  { label: 'W2', revenue: 29700 },
  { label: 'W3', revenue: 34100 },
  { label: 'W4', revenue: 38200 }
];

export const recentOrders = [
  {
    id: 'TTA-1041',
    customer: 'Elena Martin',
    amount: '$118.00',
    status: 'Paid',
    date: '2026-05-27'
  },
  {
    id: 'TTA-1040',
    customer: 'Artem Kyrylov',
    amount: '$48.99',
    status: 'Shipped',
    date: '2026-05-27'
  },
  {
    id: 'TTA-1039',
    customer: 'Nina Hollow',
    amount: '$212.50',
    status: 'Awaiting Payment',
    date: '2026-05-26'
  },
  {
    id: 'TTA-1038',
    customer: 'Dmytro Volkov',
    amount: '$77.40',
    status: 'Paid',
    date: '2026-05-26'
  }
];

export const products = [
  { sku: 'TS-001', name: 'Oversized Logo Tee', stock: 62, price: '$35.00' },
  { sku: 'JK-072', name: 'Street Utility Jacket', stock: 19, price: '$129.00' },
  { sku: 'HD-034', name: 'Classic Hoodie', stock: 8, price: '$79.00' },
  { sku: 'PT-990', name: 'Tech Cargo Pants', stock: 44, price: '$95.00' }
];

export const customers = [
  { name: 'Elena Martin', orders: 8, spent: '$924.50', tier: 'Gold' },
  { name: 'Artem Kyrylov', orders: 3, spent: '$248.20', tier: 'Silver' },
  { name: 'Nina Hollow', orders: 12, spent: '$1,430.10', tier: 'Platinum' },
  { name: 'Dmytro Volkov', orders: 2, spent: '$99.99', tier: 'Bronze' }
];